import { colors } from "components/Theme/WebTheme.js";
import { container, primaryColor } from "./material-kit-react.js"

const footerStyle = {
  block: {
    color: "inherit",
    padding: "0.9375rem",
    fontWeight: "500",
    fontSize: "12px",
    textTransform: "uppercase",
    borderRadius: "3px",
    textDecoration: "none",
    position: "relative",
    display: "block"
  },
  left: {
    float: "left!important",
    display: "block"
  },
  right: {
    margin: "0",
    float: "right!important"
  },
  footer: {
    padding: "0.9375rem 0",
    textAlign: "center",
    display: "flex",
    width: "100%",
    zIndex: "2",
    position: "relative"
  },
  a: {
    color: primaryColor,
    textDecoration: "none",
    backgroundColor: "transparent"
  },
  footerWhiteFont: {
    "&,&:hover,&:focus": {
      color: colors.WHITE
    }
  },
  container,
  list: {
    marginBottom: "0",
    padding: "0",
    marginTop: "0"
  },
  inlineBlock: {
    display: "inline-block",
    padding: "0px",
    width: "auto"
  },
  icon: {
    width: "18px",
    height: "18px",
    position: "relative",
    top: "3px"
  },
  homeFooter: {
    backgroundColor: colors.HEADER,
    color: colors.Header_Text,
    padding: "1.5rem 0"
  },
  homeContainer: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "0.75rem",
    justifyContent: "center"
  },
  homeNavigation: {
    width: "100%"
  },
  homeList: {
    alignItems: "center",
    display: "flex",
    flexWrap: "wrap",
    gap: "0.25rem 0.5rem",
    justifyContent: "center"
  },
  homeLink: {
    color: colors.Header_Text,
    padding: "0.65rem 0.75rem",
    "&:hover,&:focus": {
      color: colors.Button_Primary,
      textDecoration: "none"
    }
  },
  homeCopyright: {
    color: colors.Header_Text,
    fontSize: "0.875rem",
    lineHeight: 1.5,
    textAlign: "center"
  },
  homeCompanyLink: {
    color: colors.Button_Primary,
    textDecoration: "none",
    "&:hover,&:focus": {
      color: colors.WHITE,
      textDecoration: "underline"
    }
  }
};
export default footerStyle;
